export type DaysOpenTone = 'usual' | 'longer';

export interface DaysOpenDescription {
  daysOpen: number;
  typicalDays: number;
  tone: DaysOpenTone;
}

/** A listing has to be this many times the role's median, and at least this old, before it reads as "longer than usual". */
export const DAYS_OPEN_LONGER_RATIO = 1.5;
export const DAYS_OPEN_LONGER_MIN_DAYS = 14;

/**
 * Turns "posted N days ago" plus the role's median days-open (SalaryStatistics.medianDaysOpen)
 * into the one comparison the brand rail prints. Returns null whenever either side is missing,
 * so the rail simply omits the line rather than guessing. A young listing is never called
 * "quick": the only judgement made is "longer than usual", and only once the listing is both
 * clearly older than the median and at least two weeks old, so a fresh posting against a role
 * with a very short median can't be flagged.
 */
export function describeDaysOpen(daysOpen: number | null | undefined, typicalDays: number | null | undefined): DaysOpenDescription | null {
  if (typeof daysOpen !== 'number' || !Number.isFinite(daysOpen) || daysOpen < 0) return null;
  if (typeof typicalDays !== 'number' || !Number.isFinite(typicalDays) || typicalDays <= 0) return null;
  const rounded = Math.round(daysOpen);
  const typical = Math.round(typicalDays);
  const longer = rounded >= DAYS_OPEN_LONGER_MIN_DAYS && rounded > typical * DAYS_OPEN_LONGER_RATIO;
  return { daysOpen: rounded, typicalDays: typical, tone: longer ? 'longer' : 'usual' };
}
